import {Box,TextField} from '@mui/material';
import {DefaultConfig} from '../../../core/utilities/Utilities';
const readOnlyBackgroundColor=DefaultConfig.readOnlyBackgroundColor;

const FieldStaticValue=({row,fieldName,application})=>{
    const fieldProp=row?.[fieldName];
    const color=fieldProp?.ui_color;
    // Keep this a CONTROLLED input at all times - coerce null/undefined to ''
    // (never null, which React warns about on an <input value>), but preserve
    // real falsy values like 0 / false so they still render.
    const value=fieldProp?.value??'';
    return (
        <Box sx={{flex:1,minWidth:0}}>
            <TextField
                style={{marginTop:"0px",marginBottom:"8px"}}
                InputProps={{readOnly:true}}
                InputLabelProps={{shrink:value!==''}}
                sx={{input:{color:{color},backgroundColor:readOnlyBackgroundColor}}}
                id={fieldName}
                fullWidth
                name={fieldName}
                variant="outlined"
                size="small"
                label={fieldProp?.ui_label_locale?application.getLocale(fieldProp?.ui_label_locale):fieldName}
                value={value}
                margin="normal"/>
        </Box>
    );
}

export default FieldStaticValue;
